import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

/** Shown when a non-team account signs in to the Dev editor. It says where they belong rather than
 *  redirecting silently, so a stale bookmark gets fixed once. */
@Component({
  selector: 'app-team-only',
  standalone: true,
  template: `
    <div class="min-h-screen flex items-center justify-center bg-gray-950 text-gray-200 px-6">
      <div class="max-w-md text-center space-y-4">
        <h1 class="text-xl font-semibold">This editor is for the Zavo team</h1>
        <p class="text-sm text-gray-400">It runs changes we haven't released yet. Your projects are in the Zavo editor.</p>
        <a href="https://zavo.build" class="inline-block px-4 py-2 rounded-lg bg-orange-500 text-white text-sm font-medium hover:bg-orange-600">
          Go to zavo.build
        </a>
      </div>
    </div>
  `,
})
export class TeamOnlyComponent implements OnInit {
  private authService = inject(AuthService);

  ngOnInit(): void {
    // The page signs the account out, so nothing races a redirect away from it.
    this.authService.signOut().catch(() => {});
  }
}
